// Настройки представления личного стенда develop4.
export const isDevelop4Stand = () =>
  typeof window !== 'undefined' && window.location.hostname === 'develop4.contracteum.com';
